import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Buttons from "../../components/Button/Button";
import { useHistory } from "react-router-dom";
import "./Dashboard.scss";
import ViralLoops from "viral-loops-react";
const Referral = () => {
	const history = useHistory();
	const { t } = useTranslation();
	const [show, setshow] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setshow(true);
		}, 1000);
	}, []);
	return (
		<>
			<div className="home">
				<div className="left">
					<CustomerDashboard />
				</div>
				<div className="right">
					<div className="top">
						<h4>{t("home")}</h4>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-arround",
							}}
						>
							<Buttons
								style={{ width: "180px", marginRight: "0px" }}
								text={t("new-campaign")}
								onClick={() => history.push("/")}
							/>
							<Langtrans
								style={{ marginRight: "0px", marginTop: "0px", height: "36px" }}
								dashboard
							/>
						</div>
					</div>
					<div className="bottom">
						<hr />
						{show && (
							<div
								className="bottom-top"
								style={{
									height: "80vh",
									display: "flex",
									alignItems: "center",
								}}
							>
								<ViralLoops
									publicToken="UVigRNmD6jChynP12cWT1KYnuS0"
									formWidget
									milestoneWidget
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};
export default Referral;
